export const LOGIN_ADMIN_REQ = 'LOGIN_ADMIN_REQ';
export const LOGIN_ADMIN_SUCCESS = 'LOGIN_ADMIN_SUCCESS';
export const LOGIN_ADMIN_FAIL = 'LOGIN_ADMIN_FAIL';
export const LOAD_ADMIN_SUCCESS = 'LOAD_ADMIN_SUCCESS';
export const LOAD_ADMIN_FAIL = 'LOAD_ADMIN_FAIL';
export const GET_USERS_REQ = 'GET_USERS_REQ';
export const GET_USERS_FAIL = 'GET_USERS_FAIL';
export const GET_USERS_SUCCESS = 'GET_USERS_SUCCESS';
export const GET_PRODUCTS_REQ = 'GET_PRODUCTS_REQ';
export const GET_PRODUCTS_FAIL = 'GET_PRODUCTS_FAIL';
export const GET_PRODUCTS_SUCCESS = 'GET_PRODUCTS_SUCCESS';
export const GET_PRODUCTS_STATS_REQ = 'GET_PRODUCTS_STATS_REQ';
export const GET_PRODUCTS_STATS_FAIL = 'GET_PRODUCTS_STATS_FAIL';
export const GET_PRODUCTS_STATS_SUCCESS = 'GET_PRODUCTS_STATS_SUCCESS';
export const CREATE_PRODUCTS_REQ = 'CREATE_PRODUCTS_REQ';
export const CREATE_PRODUCTS_FAIL = 'CREATE_PRODUCTS_FAIL';
export const CREATE_PRODUCTS_SUCCESS = 'CREATE_PRODUCTS_SUCCESS';
export const CREATE_PRODUCTS_RESET = 'CREATE_PRODUCTS_RESET';
export const GET_ORDER_REQ = 'GET_ORDER_REQ';
export const GET_ORDER_FAIL = 'GET_ORDER_FAIL';
export const GET_ORDER_SUCCESS = 'GET_ORDER_SUCCESS';
export const GET_RECENTSALES_REQ = 'GET_RECENTSALES_REQ';
export const GET_RECENTSALES_FAIL = 'GET_RECENTSALES_FAIL';
export const GET_RECENTSALES_SUCCESS = 'GET_RECENTSALES_SUCCESS';
export const APPROVE_ORDER_REQ = 'APPROVE_ORDER_REQ';
export const APPROVE_ORDER_SUCCESS = 'APPROVE_ORDER_SUCCESS';
export const APPROVE_ORDER_FAIL = 'APPROVE_ORDER_FAIL';
export const APPROVE_ORDER_RESET = 'APPROVE_ORDER_RESET';
